/**
 * Muted "already managed" chip, shared by all card types.
 *
 * Moved verbatim out of CandidateCard.tsx (which re-exports it) when that file sat at the 500-line
 * ceiling and the ✉️ email chip needed its lines there.
 */
export function HandledChip({ label }: { label: string }) {
  return (
    <span className="shrink-0 rounded-full bg-gray-100 px-2.5 py-1 text-xs font-semibold text-gray-400">
      {label}
    </span>
  );
}
